import { useMutation, gql } from "@apollo/client";
import { AcceptTermsMutation, AcceptTermsMutationVariables, CalculationInput, ConsentData, SetContractorAndInsuredPersonInput } from "../types/types";
import { useGeneralSoContext } from "src/common/context";

const ACCEPT_TERMS_MUTATION = gql(`
  mutation AcceptTerms($id: String!, $offerId: String!, $consent: ConsentInput!, $input: SetContractorAndInsuredPersonInput!, $calculationInput: CalculationInput) {
      acceptTerms(id: $id, offerId: $offerId, consent: $consent, input: $input, calculationInput: $calculationInput)
  }
`);

export function useAcceptTerms() {
  const { soId, offerId } = useGeneralSoContext();

  const [mutation, info] = useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(ACCEPT_TERMS_MUTATION);
  const acceptTerms = async (input: SetContractorAndInsuredPersonInput, calculationInput: CalculationInput, consent: ConsentData) => {
    const { data } = await mutation({
      variables: { 
        id: soId!,
        offerId: offerId!,
        consent: { consent },
        input,
        calculationInput
      },
    });
    if (data?.acceptTerms) {
      
    }
    return data;
  };
  return [acceptTerms, info] as const;
}
